import { DialogComponentNames, tokens } from '../Dialog/tokens';

export const isFullScreenDialogOpen = () =>
  Boolean(document.querySelector(`[data-component="${DialogComponentNames.overlay}-fullscreen"][data-state="open"]`));

export const ABOVE_FULLSCREEN_DIALOG_Z_INDEX = `calc(${tokens.Dialog.Overlay.topLayerIndex} + 1)`;
